import React from 'react'
import { Route, Redirect } from 'react-router-dom'

const GuardedAdminRoute = ({ component: Component, ...rest }) => {
  let _user = JSON.parse(localStorage.getItem('user'))
  const user = _user?.user
  

  return (
    <Route
      {...rest}
      render={(props) =>
        user && user.role === 'IVR_ADMIN' ? (
          <Component {...props} {...rest} />
        ) : user && user.role === 'IVR_USER' ? (
          <Redirect to="/dashboard" />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  )
}

export default GuardedAdminRoute